'use client'

import Image from 'next/image'
import { CareAndShareContainer } from './container'

import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Autoplay from 'embla-carousel-autoplay'
import { useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'

export const CareShareCharityActivities = () => {
  const t = useTranslations()

  const [api, setApi] = useState<CarouselApi | null>(null)
  const [index, setIndex] = useState(0)

  useEffect(() => {
    if (!api) return

    const handleSelect = () => {
      setIndex(api.selectedScrollSnap())
    }

    handleSelect()
    api.on('select', handleSelect)

    return () => {
      api.off('select', handleSelect)
    }
  }, [api])

  const images = [
    {
      src: '/image/November2023/mceclip2_55.jpg',
      alt: `${t(
        'care_and_share_hardcode.charity_activities.image_alt_prefix'
      )} 1`,
    },
    {
      src: '/image/November2023/mceclip3_90.jpg',
      alt: `${t(
        'care_and_share_hardcode.charity_activities.image_alt_prefix'
      )} 2`,
    },
    {
      src: '/image/November2023/mceclip4_14.jpg',
      alt: `${t(
        'care_and_share_hardcode.charity_activities.image_alt_prefix'
      )} 3`,
    },
    {
      src: '/image/November2023/mceclip5_21.jpg',
      alt: `${t(
        'care_and_share_hardcode.charity_activities.image_alt_prefix'
      )} 4`,
    },
    {
      src: '/image/November2023/mceclip6_83.jpg',
      alt: `${t(
        'care_and_share_hardcode.charity_activities.image_alt_prefix'
      )} 5`,
    },
    {
      src: '/image/November2023/mceclip7_37.jpg',
      alt: `${t(
        'care_and_share_hardcode.charity_activities.image_alt_prefix'
      )} 6`,
    },
  ]

  return (
    <CareAndShareContainer className='bg-neutral-100'>
      <h2 className='text-center font-criteria text-2xl font-bold uppercase leading-8 text-neutral-900 lg:mb-8 lg:text-4xl lg:leading-13'>
        {t.rich('care_and_share_hardcode.charity_activities.title', {
          br: () => <br className='lg:hidden' />,
        })}
      </h2>

      <Carousel
        setApi={setApi}
        opts={{
          align: 'start',
          duration: 50,
          slidesToScroll: 1,
          loop: true,
        }}
        plugins={[
          Autoplay({
            delay: 3000,
            stopOnInteraction: false,
          }),
        ]}
        className='mt-4 w-full'
      >
        <CarouselContent>
          {images.map((image, index) => (
            <CarouselItem
              className='w-full pl-4 first-of-type:pl-0 last-of-type:pr-3 md:basis-1/2 lg:basis-1/3'
              key={index}
            >
              <Image
                src={ImageHelper.getImageUrl(image.src)}
                alt={image.alt}
                width={500}
                height={290}
                className='h-72 w-full rounded-2xl object-cover'
              />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselNavigation />
      </Carousel>
      <div className='lg:mx-auto lg:mt-10 lg:max-w-xl'>
        <div className='mt-5 flex items-center gap-2 border-b border-b-neutral-900/20 pb-4 lg:justify-center'>
          <Image
            src={ImageHelper.getImageUrl(
              '/image/November2023/mceclip0_81.png',
              '270_306'
            )}
            alt={t('care_and_share_hardcode.charity_activities.logo_alt')}
            width={116}
            height={50}
            unoptimized
          />
          <Image
            src={ImageHelper.getImageUrl(
              '/image/November2023/mceclip1_10.png',
              '270_306'
            )}
            width={160}
            height={28}
            alt={t(
              'care_and_share_hardcode.charity_activities.operation_smile_logo_alt'
            )}
            unoptimized
          />
        </div>
        <p className='mt-4 text-lg leading-normal text-neutral-900/80'>
          {index <= 2
            ? t('care_and_share_hardcode.charity_activities.description_1')
            : t('care_and_share_hardcode.charity_activities.description_2')}
        </p>
      </div>
    </CareAndShareContainer>
  )
}

function CarouselNavigation() {
  return (
    <>
      <CarouselPrevious
        className='absolute -left-3 top-1/2 h-7 w-7 -translate-y-1/2'
        variant='black'
        hideIfStart
      />
      <CarouselNext
        className='absolute -right-3 top-1/2 h-7 w-7 -translate-y-1/2'
        variant='black'
        hideIfEnd
      />
    </>
  )
}
